import apiInstance from "@services/Shared/instanceAxios";

const deleteProject = (uuid: string) =>
  apiInstance({
    url: `/projects/${uuid}`,
    method: "delete",
  });

export default deleteProject;
